import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { Segmented, Spin, Input, Skeleton, Divider, Button, Select, Col, Row, message, Space, ConfigProvider, Tab, Carousel } from "antd";
const SelectGroup = ({
    setTotal = () => { },
    total = 0,
    data = [],
    list_data = [],
    setData = () => { },
    set_list_data = () => { },
    org_data = [],
    org_list_data = [],
}) => {
    const [select_type, set_select_type] = useState([]);
    // const [org_data, set_org_data] = useState([])
    useEffect(() => {
        set_select_type([]);
    }, [window.location.pathname])
    useEffect(() => {
        if (select_type.length == 0) {
            setData(org_data);
            set_list_data(org_list_data);
        } else {
            let data_tmp = [];
            org_data && org_data.map((item) => {
                if (select_type.includes(item.file_type)) {
                    // return item;
                    data_tmp.push(item);
                }
                // }
            })
            setData(data_tmp);
            let data_tmp_list = [];
            org_list_data && org_list_data.map((item) => {
                if (select_type.includes(item.file_type)) {
                    // return item;
                    data_tmp_list.push(item);
                }
            })
            set_list_data(data_tmp_list);
            setTotal(data_tmp.length);
        }

    }, [select_type])
    return (
        <>
            <Select
                value={select_type}
                style={{ width: '250px' }}
                mode="multiple"
                options={[{
                    label: 'pdf',
                    value: 'pdf'
                }, {
                    label: '文件',
                    value: 'doc'
                }, {
                    label: '簡報',
                    value: 'ppt'
                }, {
                    label: 'Excel',
                    value: 'excel'
                }, {
                    label: '影片',
                    value: 'video'
                }, {
                    label: '音源',
                    value: 'audio'
                }, {
                    label: '圖片',
                    value: 'pic'
                }]}
                onChange={value => set_select_type(value)}
            />
        </>
    )
}
export default SelectGroup;